import { useContext } from 'react'
import CurrencyContext from 'contexts/currencyContext'
import GeoContext from 'contexts/geoContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { formatCurrency } from 'lib/format/formatCurrencyIntl'
import { getAvailableInsuranceBenefits } from 'luxPlus/selectors/benefits/insurance'

function formatValue(view: App.Checkout.LuxPlusInsuranceBenefits, currency: string, regionCode: string, type: 'insurance' | 'bookingProtection', showBookingProtectionPercentage?: boolean): string | null {
  const value = type === 'insurance' ? view.insuranceTotalMemberMaxSavings : view.bookingProtectionMemberMaxSavings
  // (type === 'bookingProtection' && showBookingProtectionPercentage) is a temporary fix wile we figure out how to get an extra quote for booking protect for luxplus prices
  if (value < view.luxPlusDiscountValueDisplayThreshold || (type === 'bookingProtection' && showBookingProtectionPercentage)) {
    return `${view.luxPlusDiscountPercentage}%`
  } else {
    return formatCurrency(value, currency, regionCode, { format: 'rounded' })
  }
}

function useLuxPlusInsuranceAvailableCopy({ showBookingProtectionPercentage = false }) {
  const luxPlusInsuranceBenefitView = useAppSelector(getAvailableInsuranceBenefits)
  const geo = useContext(GeoContext)
  const contextCurrency = useContext(CurrencyContext)
  const baseString = 'Save up to'

  const formattedInsuranceValueString = luxPlusInsuranceBenefitView.insuranceTotalMemberMaxSavings ?
    `${formatValue(luxPlusInsuranceBenefitView, contextCurrency, geo.currentRegionCode, 'insurance')}` : ''

  const formattedBookingProtectionValueString = luxPlusInsuranceBenefitView.bookingProtectionMemberMaxSavings ?
    `${formatValue(luxPlusInsuranceBenefitView, contextCurrency, geo.currentRegionCode, 'bookingProtection', showBookingProtectionPercentage)}` : ''

  if (luxPlusInsuranceBenefitView.insuranceAvailable && formattedInsuranceValueString && luxPlusInsuranceBenefitView.bookingProtectionAvailable && formattedBookingProtectionValueString) {
    return `${baseString} ${formattedInsuranceValueString} on insurance or ${baseString} ${formattedBookingProtectionValueString} on cancellation protection when you add it to this booking`
  } else if (luxPlusInsuranceBenefitView.insuranceAvailable && formattedInsuranceValueString) {
    return `${baseString} ${formattedInsuranceValueString} on insurance when you add it to this booking`
  } else if (luxPlusInsuranceBenefitView.bookingProtectionAvailable && formattedBookingProtectionValueString) {
    return `${baseString} ${formattedBookingProtectionValueString} on cancellation protection when you add it to this booking`
  }
  return ''
}

export default useLuxPlusInsuranceAvailableCopy
